// app/javascript/controllers/spinner_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    // intercetto tutti i submit dei form
    document.addEventListener("submit", (event) => {
      this.show()
    })

    // se usi Turbo, nascondi quando finisce
    document.addEventListener("turbo:submit-end", (event) => {
      this.hide()
    })
  }

  show() {
    this.overlayTarget.classList.remove("hidden")
  }

  hide() {
    this.overlayTarget.classList.add("hidden")
  }
}
